import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {PasswordResetService} from '../../../../services/user/password-reset.service';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';

@Component({
  selector: 'app-password-reset',
  styleUrls: ['./password-reset.component.scss'],
  templateUrl: './password-reset.component.html',
})
export class PasswordResetComponent implements OnInit {

  private token: string;
  public passwordForm: FormGroup;
  public errorMessage: string;
  public isSuccessful = false;

  constructor(private formBuilder: FormBuilder,
              private activatedRoute: ActivatedRoute,
              private resetPasswordService: PasswordResetService) {

    this.activatedRoute.queryParams
      .subscribe((params) => {
        this.token = params.token;
      });
  }

  ngOnInit(): void {
    this.passwordForm = this.formBuilder.group({
        password: ['', Validators.required],
        passwordConfirm: ['', Validators.required]
      });
  }

  onSubmit(): void {
    this.resetPasswordService.resetPassword(this.token, this.passwordForm)
      .subscribe({
        next: () => {
          this.isSuccessful = true;
        },
        error: (err) => {
          this.isSuccessful = false;
          this.errorMessage = err.error.message;
        }
      });
  }
}
